import React, { Component } from 'react';
import { Modal, DatePicker, message, Spin } from 'antd';
import SearchInput from '../../common/SearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const dateFormat = "YYYY-MM-DD";

class UpdateRecommendSuccess extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        userOptions: [],
    }

    show = (parentRecord, record) => {
        const { userId, userCompellation, employeeCode } = parentRecord;
        const params = {
            userId,
            ...(record || {}),
            employeeCode,
            userCompellation,
        };
        this.setState({
            params,
            isEdit: !!record,
        }, () => {
            this.setState({
                visible: true,
            });
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            userOptions: [],
        });
    }

    submit = () => {
        const {
            params: {
                userId,
                userInternalRecommendId,
                successRecommendTime,
                recommendedUserId,
            },
            userOptions,
        } = this.state;
        if (!successRecommendTime) {
            message.warning('请选择成功推荐时间');
            return;
        }
        if (recommendedUserId) {
            const isExist = userOptions.some(item => item.value == recommendedUserId);
            if (!isExist) {
                message.warning('请选择正确的被推荐人');
                return;
            }
        } else {
            message.warning('请选择被推荐人');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.saveUserInternalRecommend,
            data: {
                userId,
                userInternalRecommendId,
                successRecommendTime: successRecommendTime ? successRecommendTime.slice(0, 10) : '',
                recommendedUserId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    // 员工
    userSelectChange = value => {
        const { params } = this.state;
        if (value == undefined) {
            params.recommendedUserId = '';
        } else {
            params.recommendedUserId = value.key;
        }
        this.setState({ params });
    }

    parseUserData = (res, value) => {
        if ((res.data || res.datas) ) {
            const sourceData = res.datas;
            const data = sourceData.map(item => ({
                text: `${item.userCompellation}[${item.employeeCode}]`,
                value: item.userId,
            }));
            this.setState({ userOptions: data });
        } else {
            this.setState({ userOptions: [] });
        }
    }

    getContent = () => {
        const { isEdit, params, visible, userOptions } = this.state;
        const { successRecommendTime, userCompellation, employeeCode, recommendedUserId, recommendedUserName, recommendedUserCode } = params;
        const newSuccessRecommendTime = successRecommendTime ? moment(successRecommendTime) : null;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const recommendedName = (recommendedUserName && recommendedUserCode) ? `${recommendedUserName}[${recommendedUserCode}]` : '';
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">人员:</div>
                    <div className="item-right">
                            {`${userCompellation}[${employeeCode}]`}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}成功推荐时间:</div>
                    <div className="item-right">
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 182 }}
                            format={dateFormat}
                            value={newSuccessRecommendTime}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "successRecommendTime")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}被推荐人:</div>
                    <div className="item-right">
                        {
                            visible &&
                            <SearchInput
                                name="user"
                                isEdit={isEdit}
                                style={{ width: 182 }}
                                url={API_URL.investigation.queryUserByKey}
                                keyword='keyword'
                                dataSource={userOptions}
                                parseData={this.parseUserData}
                                handleSelect={this.userSelectChange}
                                initValue={{ key: recommendedUserId, label: recommendedName }}
                                placeholder='输入姓名或工号检索'
                            />
                        }
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}内部成功推荐记录`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="420px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateRecommendSuccess;


// WEBPACK FOOTER //
// ./src/components/user/userInfo/UpdateRecommendSuccess.js